module.exports = __webpack_public_path__ + "static/media/class_4.bcd321fc.svg";